import moment from 'moment';
import { SYNCED_TEAM_MODEL, TEAM_MODEL } from './teams.model';
import TeamAvatar from 'components/base/TeamAvatar';
import { StyledTableTeamsCol } from './Teams.style';
import { DATE_FORMAT_WITH_FULL_DAY } from 'common/constants/constants';
import Icon from 'components/base/Icon';
import { memo } from 'react';
import { LBButton } from '@linearb/buzz';

export const TeamNameCol = memo(({ team }) => {
  return (
    <StyledTableTeamsCol className='name'>
      <TeamAvatar team={team} />
      <div>{team.name}</div>
    </StyledTableTeamsCol>
  );
});

export const TeamContributorsCol = memo(
  ({ team, isGroup, teamTotalContributors }) => {
    const teamDirectChildrenLength =
      (team &&
        team[TEAM_MODEL.CONTRIBUTORS] &&
        team[TEAM_MODEL.CONTRIBUTORS].length) ||
      0;
    const groupWithDirectChildrenText = `${teamTotalContributors.length} (${teamDirectChildrenLength} direct)`;
    return (
      <StyledTableTeamsCol
        className='contributors'
        data-testid='contributors-col'
      >
        {isGroup && teamDirectChildrenLength
          ? groupWithDirectChildrenText
          : teamTotalContributors.length}
      </StyledTableTeamsCol>
    );
  }
);

export const TeamCreatedAtCol = memo(({ team }) => (
  <StyledTableTeamsCol className='createdAt'>
    {moment(team[TEAM_MODEL.CREATED_AT]).format(DATE_FORMAT_WITH_FULL_DAY)}
  </StyledTableTeamsCol>
));

export const TeamOptionsCol = memo(
  ({
    team,
    isGroup,
    onConfigureTeam,
    onConfigureGroup,
    onDeleteTeam,
    onDeleteGroup,
    isCurrentUserAdminOrSuperUser,
    accounts
  }) => {
    const isTeamSynced = team?.[SYNCED_TEAM_MODEL.IS_SYNCED];
    const shouldShowDeleteButton =
      !isTeamSynced && isCurrentUserAdminOrSuperUser;

    return (
      <StyledTableTeamsCol className='options'>
        <LBButton
          variant='ghost'
          size='icon'
          data-testid='edit-btn'
          onClick={() =>
            isGroup ? onConfigureGroup(team) : onConfigureTeam({ team })
          }
        >
          {/* center pencil icon inside button (we should remove this when we replace icons with streamline) */}
          <span className='[&_svg]:mr-[10px]'>
            <Icon name='Pencil' size='small' />
          </span>
        </LBButton>
        {shouldShowDeleteButton && (
          <LBButton
            variant='ghost'
            size='icon'
            onClick={() =>
              isGroup
                ? onDeleteGroup(team, accounts)
                : onDeleteTeam(team, accounts)
            }
            data-testid='Delete-btn'
          >
            {/* center pencil icon inside button (we should remove this when we replace icons with streamline) */}
            <span className='[&_svg]:mr-[10px]'>
              <Icon name='Delete' size='small' />
            </span>
          </LBButton>
        )}
      </StyledTableTeamsCol>
    );
  }
);
